export default __webpack_public_path__ + "static/media/instagram.7e5ff9d3.svg";